export default function formatPhoneNumber(phoneNumber: string) {
  if (phoneNumber.trim().length === 12 && phoneNumber.startsWith("+1"))
    return phoneNumber.replace(/^\+\d(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
  else return phoneNumber;
}
